"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _RadioGroup = _interopRequireDefault(require("@mui/material/RadioGroup"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _mui = require("tss-react/mui");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _withFormField = _interopRequireDefault(require("../hocs/withFormField"));
var _FieldHelperText = _interopRequireDefault(require("../FieldHelperText"));
var _excluded = ["error", "success", "classes", "disabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var StyledRadio = (0, _mui.withStyles)(function (_ref) {
  var error = _ref.error,
    success = _ref.success,
    classes = _ref.classes,
    disabled = _ref.disabled,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Radio["default"], _extends({
    classes: {
      root: (0, _clsx["default"])(classes.root, !disabled && success && classes.success, !disabled && error && classes.error),
      checked: classes.checked
    },
    disabled: disabled
  }, other));
}, function (theme, _params, classes) {
  return {
    root: _defineProperty({
      padding: 0,
      margin: theme.spacing(0, 1),
      color: theme.palette.primary.main
    }, "&.".concat(classes.checked), {
      color: theme.palette.primary.main
    }),
    error: _defineProperty({
      color: theme.palette.red.main
    }, "&.".concat(classes.checked), {
      color: theme.palette.red.main
    }),
    success: _defineProperty({
      color: theme.palette.green.main
    }, "&.".concat(classes.checked), {
      color: theme.palette.green.main
    }),
    checked: {}
  };
});
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    radioContainer: {
      padding: 0,
      margin: theme.spacing(1, 0)
    },
    helperText: {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(2),
      marginTop: 0
    },
    label: {
      fontSize: 12
    }
  };
});
var RadioButtons = function RadioButtons(props) {
  var handleChange = props.handleChange,
    error = props.error,
    success = props.success,
    options = props.options,
    defaultValue = props.defaultValue,
    value = props.value,
    row = props.row,
    name = props.name,
    disabledForm = props.disabled,
    inputRef = props.inputRef,
    labelClassName = props.labelClassName;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], null, /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
    ref: inputRef,
    value: value,
    defaultValue: defaultValue,
    name: name,
    row: row,
    onChange: handleChange ? function (e) {
      return handleChange(e.target.value);
    } : undefined
  }, options && options.map(function (_ref2) {
    var optionValue = _ref2.value,
      disabled = _ref2.disabled,
      label = _ref2.label,
      details = _ref2.details;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: optionValue,
      className: classes.radioContainer
    }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
      value: optionValue,
      className: labelClassName,
      label: /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        className: classes.label
      }, label),
      disabled: disabledForm || disabled,
      control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
        error: error,
        success: success
      })
    }), !!details && /*#__PURE__*/_react["default"].createElement(_FieldHelperText["default"], {
      className: classes.helperText
    }, details));
  })));
};
var _default = (0, _withFormField["default"])({
  messagePosition: 'top'
})(RadioButtons);
exports["default"] = _default;
RadioButtons.propTypes = {
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  })]),
  name: _propTypes["default"].string,
  row: _propTypes["default"].bool,
  success: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  handleChange: _propTypes["default"].func,
  labelClassName: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string,
    details: _propTypes["default"].string,
    disabled: _propTypes["default"].bool
  })).isRequired
};
RadioButtons.defaultProps = {
  inputRef: undefined,
  value: undefined,
  defaultValue: undefined,
  handleChange: undefined,
  labelClassName: undefined,
  row: undefined,
  name: undefined,
  error: false,
  success: false,
  disabled: false
};